export default {
    name: "StudyMixin",
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            STUDY: 'kenya'
        };
    },
    computed: {},
    created: function () {
        this.STUDY = process.env.VUE_APP_STUDY ? process.env.VUE_APP_STUDY : 'kenya';
    },
    methods: {},
};
